import React from 'react';
import { Redirect } from 'react-router-dom';

const About = () => {
  return <Redirect to='/404' />;
};

export default About;
